import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import styled from "styled-components";
import Button from "../button/button";
import { IoMdClose } from "react-icons/io";

const ModalHeader = styled.h3`
font-size: 16px;
font-weight: 600;
color: black;
`;

const ModalSubHeader = styled.h3`
font-size: 14px;
font-weight: 400;
color: black;
`;

const ModalContainer = styled.div`
  width: 500px;
  max-width: 800px;
  height: auto;
`;
const ButtonWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;
const ModelTitle = styled.h3`
font-size: 20px;
font-weight: 500;
color: black;
`;

export default function NoteModal(props) {
    return (
        <Modal
            open={props.open}
            onClose={props.onCloseModal}
            classNames="modalContent"
            closeOnEsc={true}
            center={true}
            closeOnOverlayClick={true}
        >
            <ModalContainer>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                <ModelTitle>{props.title}</ModelTitle>
                <IoMdClose size={24} color="black" onClick={props.onCloseModal}/>
                </div>
                {props.content}
            </ModalContainer>
        </Modal>
    )
}